import handleLoad from './handleLoad';

/**
 * Returns a callback to reset index and reload data.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @return {Function} A callback function
 */
const handleReset = (component, $itemTemplate) => () => {
    $(component).attr('data-index', 0);
    handleLoad(component, $itemTemplate)();
};

export default handleReset;



// WEBPACK FOOTER //
// ./src/scripts/components/references/handleReset.js